// export const BASE_URL = "http://localhost:8000";
export const BASE_URL = "https://mvp.isupec.ac.mz/starter";

export const API_PATHS = {
  AUTH: {
    REGISTER: "/api/users/register",
    LOGIN: "/api/login",
    GET_PROFILE: "/api/user/",
    UPDATE_PASSWORD: "/api/users/update-password",
    SEND_SMS: "/api/auth/sendSmsUser",
    GET_OPT_CODE: "/api/opt/getOptCode",
    ACTIVE_ACCOUNT: "/api/auth/active-account",
    GET_COMMISSION_STATE: "/api/users/getReferrals",
    UPGRADE_PLAN: "/api/users/upgrade-plan",
  },

  LOCATION: {
    index: "/api/provinces",
    locations: "/api/countries",
  },
  COURSES: {
    AllCourses: "/api/getCourse",
  },
  STUDENT: {
    updateCandidate: (person_id) =>
      `/api/estudantesCandidante?person_id=${person_id}`,
  },

  DEPARTMENTS: {
    getDepartmentWithPagination: (params) => `/api/department?${params}`,
    DeleteDepartment: (id) => `/api/department/${id}`,
    updateDepartment: (id) => `/api/department/${id}`,
  },

  SYSTEMUSERS: {
    index: (page, searchQuery) =>
      `/api/admin/users/?page=${page}&search=${searchQuery}`,
    add: "/api/admin/users/",
    delete: (id) => `/api/admin/users/${id}/`,
    find: (id) => `/api/admin/users/${id}/`,
    update: (id) => `/api/admin/users/${id}/`,
  },

  PERMISSIONS: {
    index: (page, searchQuery) =>
      `/api/admin/permissions/?search=${searchQuery}&page=${page}&sort_field=name&sort_order=asc`,
    add: "/api/admin/permissions",
    delete: (id) => `/api/admin/permissions/${id}`,
    update: (id) => `/api/admin/permissions/${id}`,
  },

  ROLES: {
    index: (page, searchQuery) =>
      `/api/admin/roles/?search=${searchQuery}&page=${page}&sort_field=name&sort_order=asc`,
    add: "/api/admin/roles",
    delete: (id) => `/api/admin/roles/${id}`,
    update: (id) => `/api/admin/roles/${id}`,
    create: `/api/admin/allpermissions`,
    edit: (id) => `/api/admin/edit/${id}`,
  },

  REPORTS: {
    index: () => `/api/admin/customer/reports/statistics`,
    listData: () => `/api/admin/customer/reports/list`,
    PRODUCTS: {
      index: (params) => `/api/admin/products/reports/statistics?${params}`,
      productsReport: (params) =>
        `/api/admin/products/reports/productsReport?${params}`,
      graphicStatistics: (params) =>
        `/api/admin/products/reports/graphicStatistics?${params}`,
    },
    SALES: {
      index: (params) => `/api/admin/sales/reports/sales?${params}`,
    },
  },

  SYSTEMGROUP: {
    index: (page, searchQuery) =>
      `/api/accounts/groups/?page=${page}&search=${searchQuery}`,
    add: `/api/accounts/groups/`,
    delete: (id) => `/api/accounts/groups/${id}`,
    add_user_to_group: (id) => `/api/accounts/users/${id}/add-group/`,
  },

  TOKEN: {
    VERIFY_TOKEN: "/api/unlock/unlockToken",
  },
  DASHBOARD: {
    RESUM_INFO: "/api/admin/dashboard/stats/",
    FILTER_CONTENT: (start_month, end_month, year) =>
      `/api/filterByBetweenInterval/?start_month=${start_month}&end_month=${end_month}&year=${year}`,
  },
  // PRODUCTSVIEW: {
  //   index: (page, searchQuery) =>
  //     `/api/products?page=${page}&search=${searchQuery}`,
  //   approved_process: (process_id, model, type) =>
  //     `/api/approved_process/?process_id=${process_id}&model=${model}&type=${type}`,
  //   deleteProduct: (id) => `/api/products/${id}`,
  //   find_process: (id) => `/api/products/${id}/`,
  //   updateProduct: `/api/updateProduct/`,
  //   AddProdutct: "/api/products/",
  //   reports: (model, date_start, date_end, status) =>
  //     `/api/processes/reports/?model=${model}&date_start=${date_start}&date_end=${date_end}&status=${status}`,
  //   removeImage: (id, url_img) => `/api/removeImage?query=${url_img}&id=${id}`,
  //   removeImageCover: (id, url_img) =>
  //     `/api/removeImageCover?query=${url_img}&id=${id}`,
  // },

  INSCRIPTION: {
    verifying_data: "/api/verifying_inscription_data",
    addInscriptionAttachment: "api/add_attachment_inscription",
    getAllInscription: (params) => `/api/inscriptions?${params}`,
    getInscriptionById: (id) => `/api/inscriptions/${id}`,
    confirmInscription: (id) => `/api/confirmPayment_?inscription_id=${id}`,
  },

  CUSTOMERSVIEW: {
    index: (params) =>
      `/api/Customers?${params}&sort_order=asc&sort_field=customer_name`,
    addcustomer: "/api/Customers",
  },

  PAYMENTS: {
    index: (page, searchQuery) =>
      `/api/checkout/payment?page=${page}&search=${searchQuery}`,
  },
};
